module.exports = __webpack_public_path__ + "static/img/hover8.d1157c6f.png";